'use client';

import Player from '@vimeo/player';
import { useEffect, useRef } from 'react';
import { asText, isFilled, RichTextField } from '@prismicio/client';

import { Box, CardHero } from '@preventx/oxygen';

type FigureType = 'default' | 'card-hero';

type VimeoContainerProps = {
  figureAs?: FigureType;
  caption?: RichTextField;
  vimeoId: number | undefined;
};

export const VimeoContainer = ({
  vimeoId,
  caption,
  figureAs = 'default',
}: VimeoContainerProps) => {
  const playerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (playerRef.current === null) {
      return;
    }

    new Player(playerRef.current, {
      loop: false,
      id: vimeoId,
      autoplay: false,
    });
  }, []);

  return (
    <>
      {figureAs === 'card-hero' && (
        <CardHero component="figure" ratio="widescreen">
          <Box component="div" addFeatureVideo ref={playerRef}></Box>

          {isFilled.richText(caption) && (
            <figcaption>{asText(caption)}</figcaption>
          )}
        </CardHero>
      )}

      {figureAs !== 'card-hero' && (
        <Box component="figure">
          <Box component="div" addFeatureVideo ref={playerRef}></Box>

          {isFilled.richText(caption) && (
            <figcaption>{asText(caption)}</figcaption>
          )}
        </Box>
      )}
    </>
  );
};
